<template>
  <div id="app" class="i-container">
    <transition name="slide-left">
      <router-view class='child-view'/>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'app',
  mounted(){
    this.androidStyle();
    this.removePageLoading();
  },
  methods: {
    removePageLoading() {
      let l = document.querySelector(".js-loading-spinner");
      setTimeout(()=>{
        l.parentNode.removeChild(l);
      }, 500);
    },
    androidStyle() { 
      if(this.$tool.browser.android) {
        let body = document.querySelector("body");
        body.style.setProperty('--tag-pt', '.38em');
        body.style.setProperty('--navVt', '-5.8px');
      }
    }
  }
}
</script>

<style lang="scss">
.child-view {
    transition: transform .4s, opacity .4s ;

    // &+.child-view{
    //   margin-top: -100vh;
    // }
}

.slide-left-enter, 
.slide-right-leave-active {
    opacity: 1;
    transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active, 
.slide-right-enter {
    opacity: 1;
    transform: translate3d(-100%, 0, 0);
}
</style>
